import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import { adminRoute } from "../../../config/roles";
import Profile from "../../../components/Admin/Profile";

const BASE_ROUTE = adminRoute + "/profile";

class AdminProfile extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route path={BASE_ROUTE} render={(props) => <Profile {...props} />} />
        </Switch>
      </div>
    );
  }
}

export default AdminProfile;
